export const RESPONSE_TYPE = {
  JSON: 'json',
  TEXT: 'text',
};
